var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListItem = function SvgListItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.537 5.975-4.05-4.837c-.338-.394-.956-.45-1.406-.113-.394.338-.45.956-.113 1.406l3.881 4.67H8.38c-.45-1.688-1.968-2.926-3.768-2.926A3.889 3.889 0 0 0 .73 8.056a3.89 3.89 0 0 0 3.882 3.882c1.8 0 3.318-1.238 3.768-2.925h24.526l-3.938 4.612c-.337.394-.281 1.013.113 1.406.168.17.393.225.618.225.281 0 .563-.112.731-.337l4.05-4.838c1.07-1.237 1.07-2.925.057-4.106ZM4.612 9.913A1.897 1.897 0 0 1 2.699 8c0-1.069.844-1.912 1.913-1.912 1.068 0 1.912.843 1.912 1.912a1.897 1.897 0 0 1-1.912 1.913Z",
    fill: "#D18357"
  })));
};
export default SvgListItem;